import { CssBaseline, ThemeProvider } from '@mui/material';
import { Provider } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthGate } from './guards/auth-gate';
import { AppLayout } from './layouts/app-layout';
import { AdminPage } from './pages/admin-page';
import { AdminContentfulTagsPage } from './pages/admin/contentful-tags.page';
import { AdminGeneralPage } from './pages/admin/general.page';
import { AdminMcpPage } from './pages/admin/mcp.page';
import { AdminSkillsPage } from './pages/admin/skills.page';
import { AdminToolPresetsPage } from './pages/admin/tool-presets.page';
import { AdminToolSettingsPage } from './pages/admin/tool-settings.page';
import { AdminUserPage } from './pages/admin/user.page';
import { AdminUsersPage } from './pages/admin/users.page';
import { ChatPage } from './pages/chat.page';
import { ChatsPage } from './pages/chats.page';
import { LoginPage } from './pages/login-page';
import { NotFoundPage } from './pages/not-found-page';
import { PresetsPage } from './pages/presets-page';
import { SettingsPage } from './pages/settings-page';
import { SharedChatsPage } from './pages/settings/shared-chats.page';
import { TokensPage } from './pages/settings/tokens.page';
import { SharedChatPage } from './pages/shared-chat.page';
import { store } from './store';
import { theme } from './theme';

function RedirectWithSearch({ to }: { to: string }) {
  const { search } = useLocation();

  return <Navigate to={{ pathname: to, search }} replace />;
}

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthGate>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/shared-chat/:token" element={<SharedChatPage />} />
            <Route element={<AppLayout />}>
              <Route path="/" element={<RedirectWithSearch to="/chats" />} />
              <Route path="/chats" element={<ChatsPage />} />
              <Route path="/chats/:id" element={<ChatPage />} />
              <Route path="/presets" element={<PresetsPage />} />
              <Route path="/settings" element={<SettingsPage />}>
                <Route index element={<Navigate to="tokens" replace />} />
                <Route path="tokens" element={<TokensPage />} />
                <Route path="shared-chats" element={<SharedChatsPage />} />
                <Route path="pat" element={<Navigate to="/settings/tokens" replace />} />
              </Route>
              <Route path="/admin" element={<AdminPage />}>
                <Route index element={<Navigate to="general" replace />} />
                <Route path="general" element={<AdminGeneralPage />} />
                <Route path="mcp" element={<AdminMcpPage />} />
                <Route path="users" element={<AdminUsersPage />} />
                <Route path="users/:id" element={<AdminUserPage />} />
                <Route path="tool-presets" element={<AdminToolPresetsPage />} />
                <Route path="tool-settings" element={<AdminToolSettingsPage />} />
                <Route
                  path="contentful-tags"
                  element={<AdminContentfulTagsPage />}
                />
                <Route path="skills" element={<AdminSkillsPage />} />
              </Route>
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </AuthGate>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
